<template>
  <span
    v-if="!isEditable"
    class="tw-inline-block tw-max-w-[200px] tw-truncate"
    :title="column.purchaseOrderNumber || ''"
  >
    {{ column.purchaseOrderNumber || '-' }}
  </span>
  <EditPoNumber v-else :bill-id="column.id" :po-number="column.purchaseOrderNumber || ''" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { PaymentRequestStatus } from '@/gql/graphql'
import EditPoNumber from '@/components/PaymentRequests/Client/EditPoNumber.vue'

const PaymentRequestPoNumberColumn = graphql(`
  fragment PaymentRequestPoNumberColumn on PaymentRequest {
    id
    purchaseOrderNumber
    status
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestPoNumberColumn>
}>()

const column = computed(() => useFragment(PaymentRequestPoNumberColumn, props.row))

const isEditable = computed(() => column.value.status === PaymentRequestStatus.Unapproved)
</script>
